var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-pill-tabs",class:{ 'cf-c-pill-tabs--full-height': _vm.fullHeight }},[_c('div',{staticClass:"cf-c-pill-tabs__items cf-u-m-default"},[_vm._t("tabs")],2),_c('div',{staticClass:"cf-c-pill-tabs__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }